/**
 * Copyright (c) eventlint. All Rights Reserved.
 *
 *
 * @summary
 * @author Segev {CJ} Shmueli <cj@segevs.com>
 *
 * Created: 7/1/2022
 */

const style = {
    padding: "1.5em 0",
    lineHeight: "1.75em",
    fontSize: "1.125rem",
}

const Overview = () => {

    return (
        <>
            <div className='hero'>
                <h1>Corporate Overview</h1>
            </div>

            <main style={{
                padding: "0 1.5em",
            }}>
                <p style={style}>
                    eventlint empowers event managers to automate their workflow, and get more done, faster!
                </p>

                <p style={style}>
                    Our MVP launch target date range is between <strong>August 15th, 2022</strong> and <strong>September 1st, 2022</strong> - the beginning of the <strong>New Years Eve</strong> campaign for most large event producers.
                    <br />
                    <br />
                    Until then we are <strong>talking to users</strong> and writing code! We iterate and tweak to improve our chances for a good product-market fit at launch.
                </p>

                <p style={{
                    display: 'flex',
                    gap: '3em',
                    padding: '3em 0',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                    <a href="/updates">Platform demos</a>
                    <a href="/weekly">Weekly updates</a>
                    <a href="https://eventlint.com" rel="noreferrer" target="_blank" style={{
                        background: '#fafafa',
                        border: '1px solid #e0e0e0',
                        borderRadius: '5px',
                        padding: '0.5em 1em',
                        fontSize: '1.125rem',
                        fontWeight: 'bold',
                        color: '#000',
                        textDecoration: 'none',
                        textTransform: 'uppercase',
                        letterSpacing: '0.1em',
                        transition: 'all 0.2s ease-in-out',
                    }}>Live site</a>




                </p>
                <div style={{
                    display: 'flex',
                    padding: '1em',
                    color: '#999',
                    fontSize: '0.875rem',
                }}>
                    * Link to the platform will be available shortly
                </div>




            </main>
        </>
    );
}

export default Overview;